"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _forkJoin = require("rxjs/observable/forkJoin");

var _of = require("rxjs/observable/of");

var _filter = require("rxjs/operators/filter");

var _map = require("rxjs/operators/map");

var _mergeMap = require("rxjs/operators/mergeMap");

var _concat = require("rxjs/operators/concat");

var _publishReplay = require("rxjs/operators/publishReplay");

var _refCount = require("rxjs/operators/refCount");

var _reduxObservable = require("redux-observable");

var _requestStatusChecks = require("settings-ui-sdk/utils/requestStatusChecks");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

function _default(_ref) {
  var requestEpics = _ref.requestEpics,
      mapStateToInitiatingActions = _ref.mapStateToInitiatingActions,
      metaInitiatingActionType = _ref.metaInitiatingActionType,
      metaRequestActions = _ref.metaRequestActions,
      metaRequestStatusSelector = _ref.metaRequestStatusSelector,
      _ref$metaRequestStatu = _ref.metaRequestStatusTypeFilters,
      metaRequestStatusTypeFilters = _ref$metaRequestStatu === void 0 ? [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED] : _ref$metaRequestStatu;
  return function ($action, store) {
    return $action.ofType(metaInitiatingActionType).pipe((0, _filter.filter)(function () {
      return metaRequestStatusTypeFilters.includes(metaRequestStatusSelector(store.getState()));
    }), (0, _mergeMap.mergeMap)(function () {
      var combinedEpic = _reduxObservable.combineEpics.apply(void 0, (0, _toConsumableArray2.default)(requestEpics));

      var $initatingAction = _reduxObservable.ActionsObservable.from(mapStateToInitiatingActions(store.getState()));

      var $resultAction = combinedEpic($initatingAction, store).pipe((0, _publishReplay.publishReplay)(), (0, _refCount.refCount)());
      return (0, _of.of)(metaRequestActions.request()).pipe((0, _concat.concat)($initatingAction), (0, _concat.concat)($resultAction), (0, _concat.concat)((0, _forkJoin.forkJoin)($resultAction).pipe((0, _map.map)(function (actions) {
        if (_requestStatusChecks.anyRequestsFailed.apply(void 0, (0, _toConsumableArray2.default)(actions.map(function (action) {
          return action.meta.request.status;
        })))) {
          return metaRequestActions.failure();
        }

        return metaRequestActions.success();
      }))));
    }));
  };
}

module.exports = exports.default;